import { Middleware } from 'redux';

import { enqueueInfo } from '@paragon/notification-tools';

import { RootState } from '..';
import { ReduxDispatch } from '../actions/thunkActions';
import { getPickingObjectInfo } from '../selectors/pickingSelectors';
import { getBoundedRoofAndCeilingPlaneShapesByGuid } from '../selectors/roofAndCeilingPlaneSelectors';

function getGuidOfPlaneBeingCut(state: RootState): string | null {
  const pickingInfo = getPickingObjectInfo(state);
  if (pickingInfo?.type !== 'pickingPlane') return null;
  if (pickingInfo.targetInfo.type !== 'roof-cut' && pickingInfo.targetInfo.type !== 'ceiling-cut') return null;

  return pickingInfo.targetInfo.planeGuidToCut;
}

export const incompletePlaneCutMiddleware: Middleware<{}, RootState, ReduxDispatch> = (store) => (next) => (action) => {
  const planeGuidBeingCut = getGuidOfPlaneBeingCut(store.getState());
  const result = next(action);

  if (planeGuidBeingCut && getGuidOfPlaneBeingCut(store.getState()) == null) {
    const fullyBounded = !!getBoundedRoofAndCeilingPlaneShapesByGuid(store.getState())[planeGuidBeingCut]?.length;
    if (!fullyBounded) {
      store.dispatch(
        enqueueInfo('Need help? Paragon has documentation on cutting planes.', true, {
          text: 'Get Help ↗',
          href: 'https://docs.paragontruss.com/training-c3-intermediate-layout-and-design/4.0-roof-planes/4.2-cutting-roof-planes',
        }),
      );
    }
  }

  return result;
};
